import { Component, DestroyRef, Inject, inject, OnDestroy, OnInit } from '@angular/core';
import { FeatureFlagService } from '@core/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DashboardResolve, GarageContract, ParkingSession } from '@shared/models';
import { TypedRoute } from '@shared/utils';
import { ActivatedRoute } from '@angular/router';
import { AlertService, runtimeAlerts } from '@shared/services';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit, OnDestroy {
  private destroyRef = inject(DestroyRef);
  openParkingSessions: ParkingSession[] = [];
  hasContracts = false;
  hasContractRequests = false;
  showAccountBalance: boolean = false;
  showPayPerUseDashboard: boolean = false;
  showContractRequests: boolean = false;


  constructor(
    @Inject(ActivatedRoute) private route: TypedRoute<DashboardResolve>,
    private featureFlagService: FeatureFlagService,
    private alertService: AlertService,
  ) {
    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.openParkingSessions = data.dashboardApiResponse.open_parking_sessions;
      this.hasContracts = data.dashboardApiResponse.garage_contracts.length > 0;
      if (this.hasContractsWithNoLicensePlate(data.dashboardApiResponse.garage_contracts)) {
        this.alertService.add(runtimeAlerts['contractWithoutLicensePlateAlert']);
      }
      this.hasContractRequests = data.dashboardApiResponse.contract_requests.length > 0;
      
    });
  }

  ngOnInit() {
    this.showAccountBalance = this.featureFlagService.getFeatureFlag('enable_external_billing') !== true;
    this.showPayPerUseDashboard = this.featureFlagService.getFeatureFlag('enable_ppu') === true;
    this.showContractRequests = this.featureFlagService.getFeatureFlag('enable_contract_request') === true && this.hasContractRequests;
  }

  hasContractsWithNoLicensePlate(garageContracts: GarageContract[]): boolean {
    return garageContracts.some(
      (contract) => contract.license_plates.length === 0 && (!contract.end || new Date(contract.end) > new Date()),
    );
  }

  ngOnDestroy() {
    this.alertService.removeAlert(runtimeAlerts['contractWithoutLicensePlateAlert']);
  }
}
